import { ICustomAttributes, IDeliveryType, IDisclosureTrackingMapping, IExpression, IImpersonation, IOtherControl, IPluginConfiguration } from '../plugin/IConfiguration';

export interface IPluginConfig extends IPluginConfiguration {
    AllowMultiDelivery: boolean;
    FormToolTips: ICtrlToolTips[];
}

export interface IImportPluginConfiguration {
    OtherControls: IOtherControl[];
    LastUpdateUtc: string;
    Packages: IPackageImportExport[];
    UseExpressionCaching: boolean;
    DeliveryTypes: IDeliveryType[];
    AllowMultiDelivery: boolean;
    Impersonation: IImpersonation;
    SendValidations: IExpression[];
    ErrorMessageOverrides: IErrorMessageOverrides[];
    _DefaultValues: IDefaultValuesImportExport;
    DisclosureTrackingMapping: IDisclosureTrackingMapping;
    FormToolTips: ICtrlToolTips[];
    EnableTpo: boolean;
}
export interface ICtrlToolTips {
    ControlId: string;
    ToolTip: string;
}

export interface IErrorMessageOverrides {
    RespMessage: string;
    RespOverride: string;
}

export interface IPackageImportExport {
    Group: string;
    Order: number | null;
    AltPkgId?: string;
    ParentPkgId?: string;
    ToolTipText?: string;
    ValidDeliveryTypes: string[];
    AutoSelectWhen?: string;
    Id: string;
    Caption?: string;
    Enabled?: boolean;
    Expressions?: IExpression[];
    Roles?: string[];
    Users?: any[];
    CustomAttributes?: ICustomAttributes;
    EnableForTpoUser: boolean;
}

export interface IDefaultValuesImportExport {
    IncludeDocumentData: boolean;
    FulfillmentShippingMethod: FullFillmentShippingOptions;
    SaveLoanBeforeDisclosing: SaveLoanBeforeDisclosingOptions;
    DefaultEFolder: boolean;
    DefaultDisclosureTracking: boolean;
    PreviewAttachmentsAlways: boolean;
    DisableAccessToEllieMaePortals: boolean;
    AutoRefreshOnFormFocus: boolean;
    AlternatePackageColor: string;
    RequireRefreshBeforeSubsequentSend: boolean;
    EncompassLogTemplate: string;
    RequestTypeAvailability: RequestTypeAvailability;
    DefaultRequestType: RequestType;
}

export enum FullFillmentShippingOptions {
    USPS1stClass,
    FedExNextDay,
    USPSPriority,
    UPSOvernight,
}

export enum SaveLoanBeforeDisclosingOptions {
    Always,
    WhenRecalculationsAreNotComplete,
    Never,
}

export enum RequestTypeAvailability {
    LightsOut = 1,
    LightsOn = 2,
    Both = 3
}

export enum RequestType {
    LightsOut = 1,
    LightsOn = 2,
}